import type { GeoScatterPoint } from "@/shared/charts/components/geo-scatter-chart/types";

/**
 * Ray-casting point-in-polygon test in screen-pixel space, used to detect
 * whether the cursor is over the interior of an editable AOI shape (so the
 * whole shape can be dragged) rather than over empty map or one of its
 * vertices/edges.
 */
export function isPixelInsidePolygon(
  target: [number, number],
  points: GeoScatterPoint[],
  toPixel: (point: [number, number]) => [number, number] | null
): boolean {
  const vertices = points
    .map((point) => toPixel(point.position))
    .filter((pixel): pixel is [number, number] => pixel != null);
  if (vertices.length < 3) return false;

  let inside = false;
  for (
    let index = 0, previousIndex = vertices.length - 1;
    index < vertices.length;
    previousIndex = index++
  ) {
    const vertex = vertices.at(index)!;
    const previousVertex = vertices.at(previousIndex)!;
    const crossesHorizontalRay =
      vertex[1] > target[1] !== previousVertex[1] > target[1] &&
      target[0] <
        ((previousVertex[0] - vertex[0]) * (target[1] - vertex[1])) /
          (previousVertex[1] - vertex[1]) +
          vertex[0];
    if (crossesHorizontalRay) inside = !inside;
  }

  return inside;
}
